import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { saveCustomerFormUploads } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";

const CustomerFormNext = () => {   
    
        const navigate= useNavigate();
        const [loaderspinner, setLoaderSpinner] = useState(false);
        const [isActive, setIsActive] = useState(false);
        const [isMsme, setIsMsme] = useState(false);
        const [isfssi, setIsFssi] = useState(false);
        const [filledForm, setFilledForm] = useState({});
        const [customerType, setCustomerType] = useState("");
        const toastId = React.useRef(null);
        const [loader, setLoader] = useState(false);
        const [openFinal, setOpenFinal] = useState(false);
        const [formSubmitted, setIsFormSubmiteed] = useState(false);
        const [declaration, setDeclartion]= useState(false)
        const contactEmail= localStorage.getItem("contactPersonEmail")
        const contactMobile= localStorage.getItem("contactPersonMobile")

        const [formValues, setFormValues] = useState({
              pan_card_document: null, 
              fssai_document: null, 
              tan_document: null, 
              gstin_document:null, 
              cancel_cheque_document: null, 
              undated_security_cheques_document: null, 
              address_proof_document: null, 
              declaration: "I Agree",
        
              
            });

            const [formValues2,setFormValues2] = useState({})

               useEffect(() => {
                const isAuthenticate= localStorage.getItem("isAuthenticated");
      // if(!isAuthenticate){
      //   navigate("/customer/validation");
      //   return;
      // }
     
                              let filledForm= localStorage.getItem("customerForm");
                              console.log("printing form from previous page>>> ", JSON.parse(filledForm))
                              // console.log("the previous form>> ", JSON.parse(filledForm))
                              setFormValues2(JSON.parse(filledForm));
                            },[]);

                            const handleFormChange = (field, value) => {
                              let updatedValue = value;
                              console.log("here is a formValues>> ", formValues);
                          
                              // Handle file inputs properly
                              if (field.endsWith("_document") && value instanceof File) {
                                  updatedValue = value; // Store the file object directly
                              }
                          
                              setFormValues((prevState) => ({
                                  ...prevState,
                                  [field]: updatedValue, 
                                  reference_id: formValues2.reference_id,
                              }));
                          };
                          

            const handlePreviousPage=()=>{
                navigate("/customer/registration-form");
                
            }

             const handleSubmitForm=async()=>{
                              
                              setIsActive(true)
                                // const requiredFields = [
                                //                   "gstin_document","pan_document" 
                                //                 ];
                              
                                //                 let hasError = false;
                                //   let updatedValues = { ...formValues };
                                
                                //   requiredFields.forEach(key => {
                                    
                                //     if (!updatedValues[key]) {
                                     
                                //       hasError = true;
                                //     }
                                //   });
                              
                                //   setFormValues(updatedValues); 
                              
                                //   if (hasError) {
                                //     console.log("cannot submit, fill mandatory")
                                   
                                //     if (!toast.isActive(toastId.current)) {
                                //       toastId.current = toast.error("Please Fill All The Required Fields", {
                                //         className: "small-toast"
                                //       });
                                //     }
                              
                                //     setIsActive(false)
                                    
                                //     return;
                                //   }

                                if (formValues2?.customer_type=="Sub Distributor") {
  const requiredDocs = [
    { field: 'cancel_cheque_document', label: 'Cancelled Cheque' },
    { field: 'undated_security_cheques_document', label: 'Undated Security Cheques' },
    { field: 'address_proof_document', label: 'Address Proof' }
  ];

  for (const doc of requiredDocs) {
    if (!formValues[doc.field]) {
      setIsActive(false);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(`Please upload the mandatory documents marked in astericks.`, {
          className: "small-toast"
        });
      }
      return;
    }
  }
} else {
  const allDocs = [
    { field: 'pan_card_document', label: 'PAN Card' },
    { field: 'gstin_document', label: 'GSTIN' },
    { field: 'cancel_cheque_document', label: 'Cancelled Cheque' },
    { field: 'undated_security_cheques_document', label: 'Undated Security Cheques' },
    { field: 'address_proof_document', label: 'Address Proof' }
  ];

  for (const doc of allDocs) {
    if (!formValues[doc.field]) {
      setIsActive(false);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(`Please upload the mandatory documents marked in astericks.`, {
          className: "small-toast"
        });
      }
      return;
    }
  }
}

                              console.log("final formValues>> ", formValues)
                              const formData= new FormData();

                              const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
                              
                              for (let key in formValues) {
                                if(key=="declaration"|| key=="reference_id"){
                                  continue; // Skip declaration and reference_id
                                }
                                const file = formValues[key];
                                if (file) {
                                  if (!allowedTypes.includes(file.type)) {
                                    if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.error(`File types must be PDF or Image (JPG/PNG).`, {
                                        className: "small-toast"
                                      });
                                    }
                                    // alert(`File type for ${key} must be PDF or Image (JPG/PNG).`);
                                    setIsActive(false);
                                    return;
                                  }
                                }
                              }
            
                              Object.keys(formValues).forEach(key => {
                                if (formValues[key]) {
                                    formData.append(key, formValues[key]); // Append file
                                }
                            });
            
                              // Object.entries(formValues).forEach(([key, obj]) => {
                              //   if (Array.isArray(obj.value)) {
                              //     obj.value.forEach((val, index) => {
                              //       formData.append(`${key}[${index}]`, val);
                              //     });
                              //   } else {
                              //     formData.append(key, obj.value);
                              //   }
                              // });
            
                              formData.forEach((value, key) => {
                                console.log(`${key}: ${value}`);
                              });
            
                              try{
                                const response= await saveCustomerFormUploads(formData);
                                const res= response.data;
                                console.log("Here is upload response>> ", res);
                                if(res.status){
                                  if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.success(res.message,{
                                              className: "small-toast"
                                            })
                                  }
                                  setIsFormSubmiteed(true);
                                  // setIsActive(false)
                                formData.forEach((value, key) => {
                                  console.log(`${key}: ${value}`);
                                });
                                setTimeout(()=>{
            
                                  navigate("/customer/validation")
                              }, 3000)
                                } else{
                                  if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.warning(res.message,{
                                              className: "small-toast"
                                            })
                                  }
                                  console.log("why not register>> ", res)
                                  setIsActive(false)
                                }
                              }catch(err){
                                console.log("Error uploading files>> ", err)
                                if(!toast.isActive(toastId.current)){
                                  toastId.current= toast.error(err.message,{
                                            className: "small-toast"
                                          })
                                }
                                setIsActive(false)
                              }
                               
                                
                                        // localStorage.removeItem("filledForm2");
                                        // localStorage.setItem("filledForm", JSON.stringify(formValues))
            
                                
                              }

            return(
                <>
                <ToastContainer/>
                <Grid>
                  <SimpleBackdrop openLoader={isActive}/>
                <SoftBox py={0} className="customerblock">
   <Grid container spacing={3}>
   <Grid item xs={12} lg={12} className="headerForm">
   
   <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
Customer Registration
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


   <Grid>
                 {loaderspinner ? <div style={{
                   position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                   zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                 }}>
                   <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                 </div> : ""}
   </Grid>
   
   </Grid>
   </Grid>
   </SoftBox>

    <SoftBox className="bp formBG">
        <form noValidate onSubmit={(e) => {
          e.preventDefault()
          setOpenFinal(true)
          }}>
        <SoftBox py={3} className="customerblock">
       <Grid container spacing={3}>
         <Grid item xs={12} lg={12}>
           <Card sx={{ overflow: "visible" }}>
             <SoftBox p={3}>
               <SoftTypography variant="h5" id="form_heading textUppercase">Upload Documents</SoftTypography>
<SoftTypography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
  * Only PDF or images (JPG, JPEG, PNG) are allowed with max size upto 5MB.
</SoftTypography>
               

               <SoftBox mt={1}>
                 <Grid container spacing={3}>
                 <Grid item xs={12} sm={4}>
                     <SoftBox mb={3}>
                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                         <SoftTypography
                           component="label"
                           variant="caption"
                           fontWeight="bold"
                           textTransform="capitalize"
                         >
                           FSSAI License Document {(formValues2?.fssi_regn_no!="" && formValues2?.fssi_regn_no!=null) ? <span>*</span>:<></>}
                         </SoftTypography>
                       </SoftBox>
                       <SoftInput  
                         type="file"
                         
                        //  disabled={formValues2.fssai_license_document?.value !== "Active"}
                        //  value={formValues.latest_co_status.value}
                        //  onChange={(e) => {
                        //   console.log("ffsai license is is>>> ", e.target.files[0])
                        //   handleFormChange('fssai_document', e.target.files[0])}}
                        onChange={(e) =>{
                          const file = e.target.files[0];
                          if (file) {
                            const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                            if (!allowedTypes.includes(file.type)) {
                              if(!toast.isActive(toastId.current)){
                                toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                          className: "small-toast"
                                        })
                              }
                              handleFormChange("fssai_document", file);
                              return;
                            }
                            console.log("fssai file is>>> ", file);
                            handleFormChange("fssai_document", file);
                          }
} }
                        
                         placeholder="Street"
                         id="street"
                         size="medium" />
                     </SoftBox>
                   </Grid>
                 <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                              <SoftTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold"
                                                textTransform="capitalize"
                                              >
                                                PAN Card Document {formValues2?.customer_type!=="Sub Distributor" && <span>*</span>}.
                                              </SoftTypography>
                                            </SoftBox>
                                            <SoftInput
                                              type="file"
                                              id="tds_doc"
                                              // disabled={formValues.tds_exemption?.value !== "Yes"}
                                            //   error={formValues.tds_doc.error}
                                              // value={formValues.tds_doc.value}
                                              // onChange={(e) => {
                                              //   console.log("pan file is>>> ", e.target.files[0])
                                              //   handleFormChange('pan_card_document', e.target.files[0])}}

                                                onChange={(e) =>{
                                                                                                      const file = e.target.files[0];
                                                                                                      if (file) {
                                                                                                        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                                                        if (!allowedTypes.includes(file.type)) {
                                                                                                          if(!toast.isActive(toastId.current)){
                                                                                                            toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                                                      className: "small-toast"
                                                                                                                    })
                                                                                                          }
                                                                                                          handleFormChange("pan_card_document", file);
                                                                                                          return;
                                                                                                        }
                                                                                                        console.log("pan file is>>> ", file);
                                                                                                        handleFormChange("pan_card_document", file);
                                                                                                      }
                                                  } }
                                            />
                                          </SoftBox>
                                        </Grid>
                    <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3} id="mkcustomer">
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  GSTIN Document {(formValues2?.customer_type!=="Sub Distributor" || (formValues2?.gstn!=""&&formValues2?.gstn!=null)) && <span>*</span>}
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                size="medium"
                                                name="gstn_document"
                                                id="gstn_document"
                                                // error={formValues.gstn_document.error}
                                                // value={formValues.gstn_document.value}
                                                // onChange={(e) =>{
                                                //   console.log("gstin file is>>> ", e.target.files[0])
                                                // handleFormChange('gstin_document', e.target.files[0])}}

                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("gstin_document", file);
                                                      return;
                                                    }
                                                    console.log("gstin file is>>> ", file);
                                                    handleFormChange("gstin_document", file);
                                                  }
                        } }
                                              />
                                          </SoftBox>
                                          </Grid>
                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  TAN Document
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // error={formValues.pan_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("tan file is>> ", e.target.files[0])
                                                //     handleFormChange('tan_document', e.target.files[0])
                                                // } }

                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("tan_document", file);
                                                      return;
                                                    }
                                                    console.log("gstin file is>>> ", file);
                                                    handleFormChange("tan_document", file);
                                                  }
                        } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                            </SoftBox>
                                          </Grid>

                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  Cancel Cheque*
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // disabled={formValues2.msme_registration_status?.value === ""}
                                                // error={formValues.msme_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("cancel cheque file is>> ", e.target.files[0])
                                                //     handleFormChange('cancel_cheque_document', e.target.files[0])
                                                // } }

                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("cancel_cheque_document", file);
                                                      return;
                                                    }
                                                    console.log("gstin file is>>> ", file);
                                                    handleFormChange("cancel_cheque_document", file);
                                                  }
                        } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                            </SoftBox>
                                          </Grid>

                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  3 Undated Security Cheque & Covering Letter*
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // disabled={formValues2.fssai_registration_status?.value === ""}
                                                // error={formValues.fssai_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("undated cheque file is>> ", e.target.files[0])
                                                //     if(!toast.isActive(toastId.current)){
                                                //                             toastId.current= toast.warning("NOTE: You Must Also Submit Physical copy of undated security cheques",{
                                                //                                       className: "small-toast"
                                                //                                     })
                                                //                           }
                                                //     handleFormChange('undated_security_cheques_document', e.target.files[0])
                                                // } }

                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("undated_security_cheques_document", file);
                                                      return;
                                                    }
                                                    console.log("gstin file is>>> ", file);
                                                    handleFormChange("undated_security_cheques_document", file);
                                                  }
                        } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                            </SoftBox>
                                          </Grid>

                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  Address Proof*
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // disabled={formValues2.fssai_registration_status?.value === ""}
                                                // error={formValues.address_proof_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("address file is>> ", e.target.files[0])
                                                //     handleFormChange('address_proof_document', e.target.files[0])
                                                // } }

                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("address_proof_document", file);
                                                      return;
                                                    }
                                                    console.log("gstin file is>>> ", file);
                                                    handleFormChange("address_proof_document", file);
                                                  }
                        } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                            </SoftBox>
                                          </Grid>

                 </Grid>
               </SoftBox>
                 <SoftBox py={3} className="customerblock">

                 <Grid container spacing={3}>
                 <Card sx={{ overflow: "visible" }}>
                    <SoftBox p={3}>
                        <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
<input 
// style={{marginTop:'10px'}}
type="checkbox" 
style={{ cursor: "pointer", marginTop:'10px' }} 
checked={declaration} 
onChange={(e) => setDeclartion(e.target.checked)} 
/>
<SoftTypography variant="h5" id="form_heading">
<span style={{ fontSize: "12px" }}>
I/W<span style={{textTransform: 'lowercase'}}>e</span> <span style={{textTransform: 'lowercase'}}> hereby certify that the information provided by me / us in this sheet and all attachments hereto are true and correct to the best of my / our knowledge and hereby authorize Anmol Industries Limited to check all information contained herein by whatever means finds appropriate. I / We understand that any falsification of documents and any fraudulent information or misrepresentation will serve as grounds for nullification of this application. Upon signing this Application, I / We also agree to the terms and conditions in the enclosed attachement. </span>
</span>
</SoftTypography>
</div>
<Grid container display="flex" justifyContent="space-between" mt={2} >
<Grid item>
       <SoftButton onClick={handlePreviousPage} variant="contained" color="success">
         Previous
       </SoftButton>
     </Grid>
     <Grid item>
       <SoftButton disabled={!declaration} type="submit" variant="contained" color="primary">
         Save & Submit
       </SoftButton>
     </Grid>
   </Grid>

   <Dialog open={openFinal} onClose={()=>setOpenFinal(false)} maxWidth="md" fullWidth>
    <SimpleBackdrop openLoader={isActive}/>
      <DialogTitle>Terms and Conditions</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: "60vh", overflowY: "auto" }}>
        <Typography variant="body2" component="div">
          {/* Terms and conditions text here */}
          <p>This agreement is made between the Distributor(DB)...</p>
          <p style={{fontWeight:'bold'}}>1. TERM & EFFECTIVITY :</p>
          <p>a. This contract shall be valid upto 31st March 2025</p>
          <p style={{fontWeight:'bold'}}>2. RESPONSIBILITIES OF CUSTOMER:</p>
          <p>a. Copy of the FSSAI license is displayed...</p>
          <p>b. The goods will be supplied only against advance payment only.</p>
<p>c. The Customer shall represent the interest of the Company in an honest and professional manner and at no time misrepresent the Company&rsquo;s products to any third party. The Customer shall not engage in any unfair, deceptive, misleading practice or which unfairly misleads or induces an unwilling customer to make a purchase, or which are otherwise irresponsible or not sanctioned by the Company.</p>
<p>d. The Customer abides to all governmental regulations in relation to their regular business performance including possession of valid certificates of registration under the relevant State Government / Central Government Acts. (i.e., taxes, licenses, permits, etc.) and company is not responsible or liable in any way for any type of liability arises thereof. In case, if the company needs to pay any liability due to Customer&apos;s fault then company will recover the same from the said Customer.</p>
<p>e. The Customer shall manage, train and motivate a competent team of sales personnel to sell the Company&rsquo;s products, and to implement good customer service in accordance with the sales policies of the Company.</p>
<p>f. The Customer shall arrange for adequate funds to engage in smooth running of the business and increase investment from time to time to ensure that there is no disruption in the sale of the Company&rsquo;s products within their given territory.</p>
<p>g. The Customer shall bind itself to maintain a minimum quantity of 10 days godown stock of their monthly average sale during the period of engagement.</p>
<p>h. The Customer shall allocate a suitable sales and display area for the Company&rsquo;s products.</p>
<p>i. The Customer shall ensure that the products will be sold as per the Company&rsquo;s selling norms only.</p>
<p>j. The Price of the products may be changed by the Company without any prior Notice and the Customer shall abide by them in all ways.</p>
<p>k. The Customer shall ensure that all goods are properly checked at the time of delivery. The Customer shall take possession after ensuring that there is no mismatch / deficiency during delivery of goods. The Company shall not be responsible for any damage or loss once goods delivered.</p>
<p>l. The Customer shall hold the Company free from and harmless against all claims, losses or damages incurred by its sales personnel; and shall be held liable and remain responsible for all their acts and omissions as fully as if they performed the act or omission themselves.</p>
<p>m. The Customer shall refrain from disclosing or in any way reveal, directly or indirectly, to any person or entity, details or other information contained in these terms and conditions between the Company and the Customer.</p>
<p>n. The Customer shall abide by and follow all instructions and directives of the company. And any breach will entitle the company to cancel Customership and Customer will be liable to make good the losses/expense incurred thereby the company.</p>
<p>o. All Customers shall maintain at least 2 purchase transaction/month amounting not less than Rs 1,50,000/transaction.</p>
<p>p. All Customer must give No claim certificate to the company on half yearly basis.</p>
<p>q. All Customer must deposit 3 Undated security cheque along with covering letter to the company in favour of company &quot;Anmol Industries Ltd&quot;. All cheque should be crossed as &quot;A/c payee only&quot;.</p>
<p>r. All credit claim by customer will be verified by company authorised personnel by physical inspection of the same and will be given to the extent approved by authorised personnel only. Company decision in that case will be considered final.</p>
        
<p style={{fontWeight:'bold'}}>3. RELATIONSHIP:</p>
<p>a. The Customer shall operate as an independent contractor and is not in partnership with the Company. No right has been given to the Customer to enter into any agreement or commitment in the name or on behalf of the Company or to bind the Company in any respect whatsoever. Neither shall anything contained herein or done in pursuance hereof, constitute the parties as legal representatives of the other for any purpose whatsoever.</p>
<p>b. There exists no employer-employee relationship between the Company and the Customer. Hence the Customer shall under no circumstances be considered as employees, agents, and representatives of the Company.</p>
<p>c. The Company shall not be responsible for any negligence or default of the Customer and will keep the Company indemnified against the same and all actions, proceedings, claims, demands, and expenses in relation hereto.</p>

<p style={{fontWeight:'bold'}}>4. STORAGE & GOODS:</p>
<p>a. Customer should follow FIFO method for maintaining products in godown &amp; dispatching it to customers.</p>
<p>b. Floors, ceilings and walls are maintained in a sound condition minimizing the accumulation of dirt, condensation and growth of undesirable moulds. They are made of impervious material and should be smooth and easy to clean with no flaking paint or plaster. The floors have adequate and proper drainage and are easy to clean and disinfect. Windows, doors &amp; all other openings to outside environment are well screened with wire-mesh or insect proof screen to prevent insect entry. The mesh or the screen are easy to clean.</p>
<p>c. The storage area in the customer point are effectively separated as Foods &amp; Non foods. Special care should be taken if customer is also dealing with Tea, Soap or Incense sticks industry. Product storage should not be directly exposed to toilet, urinal, drain and Market Returns &amp; Rejects.</p>
<p>d. Pest Control should be done monthly by PCI.OR any Reputed service provider. These should include the1. General Disinfestations 2. Rodent control  services. All the contract report and service reports of service provider shall be available at distribution point. Action points emerging out of pest control services shall be closed within the stipulated time frame.</p>
<p>e. The customer shall permit and allow access to the Company&rsquo;s authorized officers and representatives to inspect storage points, godowns and other premises of the customer for the purpose of checking and for ensuring by the Company that all conditions and statutory obligations pertaining to storage, etc. are being duly complied with. The Dealer shall also abide by the instructions given by the Company from time to time for storing the Product in the manner, type, fashion etc. as may be so prescribed by it based on Scientific Practices or Good Storage Practices.</p>

<p style={{fontWeight:'bold'}}>5. ADVERTISEMENT & PROMOTION:</p>
<p>a. The Company shall provide sales materials and product posters to the extent possible, to support the sales of its products.</p>
<p>b. The Customer shall not publish any advertisement which may mislead or deceive the public, or may be detrimental to the good name, trademark, logo, goodwill, or reputation of the Company.</p>
<p>c. Any advertisement or promotion efforts using the name or trademark logo of the Company must have the prior approval of the Company.</p>

   <p style={{fontWeight:'bold'}}>6. TERMINATION:</p>   
   <p>a. The contract is non-assignable, non-transferable and can be terminated by either party within thirty days from date of receipt of written notice to the other party. However Company reserves the right to immediately terminate the customer upon non compliance/violation with any of the above mentioned terms &amp; conditions.</p>  
   <p>b. Upon termination of this Contract, the Customer ceases immediately to represent, display, advertise, or promote any association with the Company.</p>
   <p>c. The Customer shall be accountable for any outstanding payments still due to the Company and must remit these payments in full.</p>

   <p style={{fontWeight:'bold'}}>7. RENEWAL</p>
   <p>a. This contract shall be automatically renewed on an annual basis under the same terms and conditions set forth in this Contract unless otherwise amended and agreed upon by either party in writing thirty days prior to the expiration of the original term.</p>
   <p style={{fontWeight:'bold'}}>8. AMENDMENT</p>
   <p>a. Any amendment, altercation or modification of this Contract shall not be valid and binding unless and until reduced in writing and signed by the parties hereto.</p>
          <p style={{fontWeight:'bold'}}>9. LEGAL VENUE:</p>
          <p>a. All legal actions and proceedings arising out of this Contract shall be subject to the jurisdiction in courts of Kolkata only.</p>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <SoftButton variant="contained" color="error" onClick={()=> setOpenFinal(false)}>
          I Disagree
        </SoftButton>
        <SoftButton variant="contained" color="success" onClick={handleSubmitForm}>
          I Agree
        </SoftButton>
      </DialogActions>
    </Dialog>
                    </SoftBox>
                 </Card>
                 </Grid>
                 </SoftBox>


             
               

               

             </SoftBox>
           </Card>
         </Grid>
       </Grid>
     </SoftBox>
        </form>
    </SoftBox>
                </Grid>
                </>
            )
}

export default CustomerFormNext;